import { Avatar, AvatarGroup, Box, ListItemButton, Tooltip, Typography } from "@mui/material"
import type { FC } from "react"

import type { SalesCustomer } from "../../types"
import { SalespersonAvatar, isValidName } from "../SalespersonAvatar"
import { resultItemSelectedSx, salespersonAvatarGroupSx } from "../styles"

import type { Location } from "@/graphql/codegen/graphql"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

interface CustomerResultItemProps {
  customer: SalesCustomer
  selected: boolean
  onSelect: (customer: SalesCustomer) => void
}

export const CustomerResultItem: FC<CustomerResultItemProps> = ({ customer, selected, onSelect }) => {
  const address = formatLocationAddress(customer.billingLocation as Location, AddressFormat.AddressOnly)

  const validSalesPersons = customer.salesPersons.filter((salesPerson) => isValidName(salesPerson.name))

  return (
    <ListItemButton
      selected={selected}
      onClick={() => onSelect(customer)}
      className='flex min-h-16 items-center justify-between px-4 py-3'
      sx={resultItemSelectedSx}
      data-testid={`sales.new-request-dialog.customer.result-${customer.companyLocationAssociationId}`}
    >
      <Box>
        <Typography className='text-base font-normal leading-6 tracking-[0.15px] text-gray-700'>
          {customer.company.name}
        </Typography>
        {address && <Typography className='text-sm text-gray-500'>{address}</Typography>}
      </Box>
      <AvatarGroup
        max={6}
        sx={salespersonAvatarGroupSx}
        renderSurplus={(surplus) => (
          <Tooltip title={validSalesPersons.map((salesPerson) => salesPerson.name.trim()).join(", ")} placement='top'>
            <Avatar>+{surplus}</Avatar>
          </Tooltip>
        )}
      >
        {validSalesPersons.map((salesPerson) => (
          <SalespersonAvatar key={salesPerson.salesmanNbr} salesPerson={salesPerson} />
        ))}
      </AvatarGroup>
    </ListItemButton>
  )
}
